import { Link } from 'react-router-dom';
import { categoryCards } from '@/mocks/homeData';

export default function CategoryNav() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索选购指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            从不同角度出发，找到最适合你的内裤选择方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categoryCards.map((card) => (
            <Link
              key={card.id}
              to={`/category/${card.slug}`}
              className="group relative bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute top-3 left-3 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 text-primary-500">
                  <i className={`${card.icon} text-lg`}></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {card.description}
                </p>
                <div className="mt-4 flex items-center text-primary-500 text-sm font-medium">
                  <span>浏览文章</span>
                  <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}